import React, { useState } from "react";
import "../../App.css";
import { Icon } from "../../components/Icon";
import { Auth } from "../../core/auth";

export function DeleteAccountModal({ user, onClose, onDeleted, showToast }) {
  const [confirmEmail, setConfirmEmail] = useState("");
  const [ack, setAck] = useState(false);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!ack) { showToast("Please confirm you understand the 30-day freeze", "error"); return; }
    if (user?.email && confirmEmail.trim().toLowerCase() !== user.email.toLowerCase()) {
      showToast("Email does not match your account", "error");
      return;
    }
    setBusy(true);
    const res = await Auth.deleteAccount({ confirmEmail: confirmEmail.trim() });
    setBusy(false);
    if (!res.ok) {
      showToast(res.error || "Could not delete account", "error");
      return;
    }
    showToast("Account deleted. You may sign up again after 30 days.", "success");
    onDeleted?.();
    onClose();
  };

  return (
    <div className="modal-box" style={{ maxWidth: 460 }} onClick={e => e.stopPropagation()}>
      <div className="modal-head">
        <div className="modal-title">Delete account</div>
        <button className="modal-close" type="button" onClick={onClose}><Icon name="close" size={14} /></button>
      </div>
      <div className="modal-body">
        <div className="form-grid">
          <p style={{ fontSize: 13, color: "var(--muted)", margin: 0, lineHeight: 1.5 }}>
            Your account will be <strong>deleted</strong> and frozen for <strong>30 days</strong> per App Store compliance.
            You will not be able to sign in during this period.
          </p>
          {user?.email && (
            <div className="f-group">
              <label className="f-label">Type your email to confirm</label>
              <input className="f-input" value={confirmEmail} onChange={e => setConfirmEmail(e.target.value)} placeholder={user.email} />
            </div>
          )}
          <label style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 12, color: "var(--ink)", cursor: "pointer" }}>
            <input type="checkbox" checked={ack} onChange={e => setAck(e.target.checked)} style={{ marginTop: 3 }} />
            <span>I understand my account will be frozen for 30 days and I cannot log in until then.</span>
          </label>
        </div>
      </div>
      <div className="modal-foot">
        <button className="btn" type="button" onClick={onClose}>Cancel</button>
        <button className="btn" type="button" style={{ background: "#DC2626", color: "#fff", border: "none" }} onClick={save} disabled={busy}>
          {busy ? "Deleting…" : "Delete my account"}
        </button>
      </div>
    </div>
  );
}
